import RegistrationForm from "./RegistrationForm"
import RegistrationLayout from "./RegistrationLayout"

export default function RegisterForm() {

	return (
		<RegistrationLayout
			title={"Welcome to RefZoom!"}
		>
			<RegistrationForm />
		</RegistrationLayout>
	)
}
